var _defs, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverPartnerMedallion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SilverPartner-medallion",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 71.079,
    viewBox: "0 0 50 71.079",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31929",
    "data-name": "Rectangle 31929",
    width: 50,
    height: 71.079,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40672",
    "data-name": "Path 40672",
    d: "M87.04,132.715a24.979,24.979,0,1,0,37.17-33.378,25.576,25.576,0,0,0-1.861-1.867L87.04,132.721Z",
    transform: "translate(-87.04 -97.47)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40673",
    "data-name": "Path 40673",
    d: "M85.76,114.733a19.831,19.831,0,1,0,19.825-20.3,20.071,20.071,0,0,0-19.825,20.3",
    transform: "translate(-85.76 -94.43)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Platinum_Partner_medallion_small",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15117",
    d: "M115.625,50.26,106.08,68.434h14.1l9.656-18.174H115.631Z",
    transform: "translate(-88.536 -50.26)",
    fill: "#b0b0af"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12265",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14182",
    "data-name": "Group 14182",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12264",
    transform: "translate(0 15.823)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15118",
    d: "M119.153,77.38h-2.095a.659.659,0,0,0-.659.659h0v1.593a1.006,1.006,0,0,1-1.009,1.009h-12.2a1.006,1.006,0,0,1-1.009-1.009h0V78.039a.659.659,0,0,0-.659-.659h-2.27a.651.651,0,0,0-.63.467L95.67,87.4h27.077l-2.952-9.557a.663.663,0,0,0-.63-.467",
    transform: "translate(-84.2 -77.38)",
    fill: "#999898"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15119",
    d: "M101.01,86.44a25,25,0,0,0-18.571,41.739l35.309-35.309A24.885,24.885,0,0,0,101.01,86.44",
    transform: "translate(-76.01 -81.154)",
    fill: "#8a8a8a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    transform: "translate(6.435 27.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14183",
    "data-name": "Group 14183",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    transform: "translate(0 -0.006)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4149",
    width: 46.394,
    height: 46.365,
    fill: "#828080"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12269",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14184",
    "data-name": "Group 14184",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12268",
    transform: "translate(4.662 25.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15121",
    d: "M104.338,94.43A20.3,20.3,0,1,1,84,114.733a20.3,20.3,0,0,1,20.338-20.3h0",
    transform: "translate(-84 -94.43)",
    fill: "#999898"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12271",
    transform: "translate(5.688 25.77)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14185",
    "data-name": "Group 14185",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4151",
    width: 39.656,
    height: 40.607,
    fill: "#8e8e8e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12273",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14186",
    "data-name": "Group 14186",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12272",
    transform: "translate(6.75 0.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15123",
    d: "M112.994,68.459h-14.1L87.58,50.32H101.9Z",
    transform: "translate(-87.58 -50.32)",
    fill: "#57a932"
  })))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40674",
    "data-name": "Path 40674",
    d: "M110.15,135.132l-6.1-10.566L97.95,114h24.4l-6.1,10.566-6.1,10.566Z",
    transform: "translate(-85.15 -76.812)",
    fill: "#bfbebf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_40675",
    "data-name": "Path 40675",
    d: "M111.266,134.467l-5.56-9.638-5.566-9.638H122.4l-5.566,9.638-5.566,9.638Z",
    transform: "translate(-86.062 -77.308)",
    fill: "#d3d3d3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverPartnerMedallion);
export default __webpack_public_path__ + "static/media/SilverPartner-medallion.b43412b55a29a60fb872beaa4e3ec027.svg";
export { ForwardRef as ReactComponent };